export class LoginFlowNotSupportedError extends Error {
  constructor(name: string) {
    super(undefined);
    this.name = name;
  }
}
